import { render, staticRenderFns } from "./SurveyBPIThanks.vue?vue&type=template&id=e7fa7c40&"
import script from "./SurveyBPIThanks.vue?vue&type=script&lang=js&"
export * from "./SurveyBPIThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports